/**
 * Self-hosted fonts require a plugin or loader in your build process that can handle loading ttf, woff, and woff2
 * files. Fonts will not be embedded within your bundle. They will be loaded from your webserver instead of a CDN.
 *
 * https://material-ui.com/customization/typography/
 */
import * as CSS from "csstype";
import ProximaNovaWoff2 from "./Proxima-Nova-Regular.woff2";
import ProximaNovaBoldWoff2 from "./Proxima-Nova-Bold.woff2";
import ProximaNovaBoldCondensedWoff2 from "./Proxima-Nova-Bold-Condensed.woff2";

export const proximaNova: CSS.FontFace = {
  fontFamily: "Proxima Nova",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 400,
  src: `
    local('Proxima-Nova-Regular'),
    url(${ProximaNovaWoff2}) format('woff2')
  `,
};

export const proximaNovaBold: CSS.FontFace = {
  fontFamily: "Proxima Nova Bold",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 700,
  src: `
    local('Proxima-Nova-Bold'),
    url(${ProximaNovaBoldWoff2}) format('woff2')
  `,
};

export const proximaNovaBoldCondensed: CSS.FontFace = {
  fontFamily: "Proxima Nova Bold Condensed",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 700,
  src: `
    local('Proxima-Nova-Bold-Condensed'),
    url(${ProximaNovaBoldCondensedWoff2}) format('woff2')
  `,
};
